export const getUserPendingAmount = (user) => {
  if (!Array.isArray(user)) return;

  const pendingAmount = user?.reduce((acc, booking) => {
    return acc + booking?.bookingGrossAmount - booking?.bookingCollectedAmount;
  }, 0);
  return pendingAmount;
};

export const getUserTotalAmount = (user) => {
  if (!Array.isArray(user)) return;
  const totalAmount = user?.reduce((acc, booking) => {
    return acc + booking?.bookingCollectedAmount;
  }, 0);
  return totalAmount;
};
